<template>
	<!--  @touchmove.prevent 弹窗滚动，禁止下方页面滚动 -->
	<el-dialog :title="title" :visible.sync="mdVisible" append-to-body :destroy-on-close="true" @close="handleCancel"
		:closeOnClickModal="false" width="60%" top="0vh" custom-class="center-dialog" :lock-scroll="false"
		@touchmove.prevent>
		<div class="popMain">
			<!-- 标题 -->
			<div class="popMainTitle">
				<h1>物流追溯平台</h1>
				<p>
					建筑行业物流追溯平台，以预制构件全过程追溯作为基础，实现全品类物料追溯为最终目标。满足客户在整个建造过程中，对场内外物料的状态精准把控。 平台利用多种技术手段，包括RFID、二维码标签和数据接口等方式，实时追踪物料的整个生命周期信息，并通过各种分析统计方式展现追溯成果。
				</p>
			</div>
			<!-- 内容 -->
			<div class="popMainItem">
				<!-- 查看报价 -->
				<div class="homeBtn">
					<a class="more-btn" @click="consultBtn">查看报价</a>
				</div>
				<div class="homeMainPC">
					<!-- 开始 -->
					<div class="inner">
						<div class="innerHd">
							<h3>全方位功能，全面信息化管理</h3>
							<p>满足不同阶段生产管理需求</p>
						</div>
						<div class="innerBd">
							<div class="innerBdList">
								<!-- 1 -->
								<div class="listSection">
									<div class="functionItem">
										<span class="functionItemIcon">
											<img src="../assets/img/pro-zdIcon1.png" alt="">
										</span>
										<span class="functionItemText">首
											&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;页</span>
									</div>
									<div class="functionItem">
										<span class="functionItemIcon">
											<img src="../assets/img/pro-zdIcon2.png" alt="">
										</span>
										<span class="functionItemText">主材看板</span>
									</div>
									<div class="functionItem">
										<span class="functionItemIcon">
											<img src="../assets/img/pro-zdIcon3.png" alt="">
										</span>
										<span class="functionItemText">场内管理</span>
									</div>
									<div class="functionItem">
										<span class="functionItemIcon">
											<img src="../assets/img/pro-zdIcon4.png" alt="">
										</span>
										<span class="functionItemText">场外管理</span>
									</div>
									<div class="functionItem">
										<span class="functionItemIcon">
											<img src="../assets/img/pro-zdIcon5.png" alt="">
										</span>
										<span class="functionItemText">材料验收</span>
									</div>
								</div>
								<!-- 2 -->
								<div class="listSection">
									<div class="functionItem">
										<span class="functionItemIcon">
											<img src="../assets/img/pro-zdIcon6.png" alt="">
										</span>
										<span class="functionItemText">试件检测</span>
									</div>
									<div class="functionItem">
										<span class="functionItemIcon">
											<img src="../assets/img/pro-zdIcon7.png" alt="">
										</span>
										<span class="functionItemText">信息管理</span>
									</div>
									<div class="functionItem">
										<span class="functionItemIcon">
											<img src="../assets/img/pro-zdIcon8.png" alt="">
										</span>
										<span class="functionItemText">数据中心</span>
									</div>
									<div class="functionItem">
										<span class="functionItemIcon">
											<img src="../assets/img/pro-zdIcon9.png" alt="">
										</span>
										<span class="functionItemText">运维中心</span>
									</div>
									<div class="functionItem">
										<span class="functionItemIcon">
											<img src="../assets/img/pro-zdIcon10.png" alt="">
										</span>
										<span class="functionItemText">系统设置</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<!-- 图片轮播开始 -->
				<div class="homeCarouselDiv">
					<el-carousel :interval="3000" type="card" height="450px" width:="100%">
						<el-carousel-item>
							<div class="item">
								<div class="itemImg">
									<img src="../assets/img/pro-zdslider1.png" alt="">
									<div class="itemImgDes" style="left: 43%;bottom: 30px;">
										<h1>
											二维码就是构件身份证
										</h1>
										<p>
											每片构件都拥有唯一的二维码作为身份确定，手机扫码查看构件参数，图纸以及生产过程记录。
										</p>
									</div>
								</div>
								<div class="itemDes">
									<img src="../assets/img/pro-zdTicon11.png" alt="">
									<p class="feature-title">一物一码</p>
									<p class="feature-intro">
										构件唯一身份
										<br>
										一物一码管理
									</p>
								</div>
							</div>
						</el-carousel-item>
						<el-carousel-item>
							<div class="item">
								<div class="itemImg">
									<img src="../assets/img/pro-zdslider2.png" alt="">
									<div class="itemImgDes" style="width:38%;left: 24%;top: 15px;">
										<h1>
											生产过程精准记录
										</h1>
										<p>
											每道工序操作人，操作时间，操作结果，扫码，精准记录。生产过程清晰，管理更轻松。
										</p>
									</div>
								</div>
								<div class="itemDes">
									<img src="../assets/img/pro-zdTicon12.png" alt="">
									<p class="feature-title">生产溯源</p>
									<p class="feature-intro">
										流程严格把控
										<br>
										掌控进度节奏
									</p>
								</div>
							</div>
						</el-carousel-item>
						<el-carousel-item>
							<div class="item">
								<div class="itemImg">
									<img src="../assets/img/pro-zdslider3.png" alt="">
									<div class="itemImgDes" style="top: 11px;width: 100%;">
										<h1>
											微信就是你的工作台
										</h1>
										<p style="text-align: center;">
											用最便捷最熟悉的方式，在手机上完成工作协同
										</p>
									</div>
								</div>
								<div class="itemDes">
									<img src="../assets/img/pro-zdTicon13.png" alt="">
									<p class="feature-title">移动协同</p>
									<p class="feature-intro">
										实时移动协同
										<br>
										信息高效沟通
									</p>
								</div>
							</div>
						</el-carousel-item>
						<el-carousel-item>
							<div class="item">
								<div class="itemImg">
									<img src="../assets/img/pro-zdslider4.png" alt="">
									<div class="itemImgDes" style="left:38%;top: 6px;width:44%">
										<h1>
											实时库存，快速定位
										</h1>
										<p>
											库存数据实时更新，解决盘点难题，快速定位构件位置，提高发货效率
										</p>
									</div>
								</div>
								<div class="itemDes">
									<img src="../assets/img/pro-zdTicon14.png" alt="">
									<p class="feature-title">堆场管控</p>
									<p class="feature-intro">
										实时库存数据
										<br>
										快速定位构件
									</p>
								</div>
							</div>
						</el-carousel-item>
						<el-carousel-item>
							<div class="item">
								<div class="itemImg">
									<img src="../assets/img/pro-zdslider5.png" alt="">
									<div class="itemImgDes" style="left:5%;bottom: 25px;width: 90%;">
										<h1>
											数据报表自动生成
										</h1>
										<p>
											浇筑入库量，发货量，库存情况，项目/生产/计划进度，你关心的运作数据，都能及时知晓
										</p>
									</div>
								</div>
								<div class="itemDes">
									<img src="../assets/img/pro-zdTicon15.png" alt="">
									<p class="feature-title">自动报表</p>
									<p class="feature-intro">
										报表自动生成
										<br>
										数据一键导出
									</p>
								</div>
							</div>
						</el-carousel-item>

					</el-carousel>
				</div>
				<!-- 图片轮播结束 -->
				<!-- 图片开始 -->
				<div class="innerFooter">
					<div class="innerBdMain">
						<div class="imgWrap">
							<viewer style="padding: 0;">
								<img src="../assets/img/pro-zdPc.png" alt="">
							</viewer>
						</div>
					</div>
					<!-- <div class="proBg"></div> -->
				</div>
				<!-- 图片结束 -->
			</div>
		</div>
		<!-- 引入咨询弹窗 -->
		<consultPop ref="consultPop"></consultPop>
	</el-dialog>
</template>
<script>
	import consultPop from '@/views/service/modules/consultPop.vue'
	export default {
		components: {
			consultPop
		},
		data() {
			return {
				mdVisible: false,
				title: "",
				srcList: []
			};
		},
		methods: {
			show() {
				this.mdVisible = true
				this.stopScroll()
			},
			close() {
				this.mdVisible = false
				this.canScroll()
			},
			handleCancel() {
				this.close()
			},
			consultBtn() {
				this.$refs.consultPop.show()
			},
			//禁止滚动
			stopScroll() {
				var mo = function (e) {
					e.preventDefault();
				};
				document.body.style.overflow = 'hidden';
				document.addEventListener("touchmove", mo, false); //禁止页面滑动
			},
			/***取消滑动限制***/
			canScroll() {
				var mo = function (e) {
					e.preventDefault();
				};
				document.body.style.overflow = ''; //出现滚动条
				document.removeEventListener("touchmove", mo, false);
			}
		},
	}
</script>

<style lang="scss">
	// 控制的dialog样式需要穿透到底层，所以这里不能写scoped属性
	// 如果不想影响全局，可以给el-dialog的父级定义一个class,再把.center-dialog置于这个class的嵌套里面
	.center-dialog {
		top: 50%;
		transform: translateY(-50%);
		border-radius: 10px;
	}

	.popMain {
		height: 60vh;
		overflow-y: auto;
		padding: 0 20px;

		.popMainTitle {
			h1 {
				font-size: 26px;
				margin-bottom: 20px;
				opacity: 0.95;
			}

			p {
				width: 100%;
				font-size: 16px;
				line-height: 28px;
				text-align: left;
				color: #333;
				opacity: 0.85;
			}
		}

		.popMainItem {
			margin-top: 30px;

			.homeMainPC {
				width: 100%;
				position: relative;

				img {
					width: 100%;
					cursor: pointer;
				}

				p {
					text-align: center;
					margin-top: 5px;
					margin-bottom: 40px;
				}
			}
		}
	}

	.popMainItem .homeMainPC p:last-child {
		margin-bottom: 0;
	}

	// ***
	.inner {
		position: relative;
		z-index: 2;

		.innerHd {
			// margin-bottom: 25px;

			h3 {
				text-align: center;
				font-size: 30px;
				font-weight: normal;
				margin-bottom: 22px;
				letter-spacing: 2px;
			}

			p {
				text-align: center;
				font-size: 16px;
				opacity: .8;
				letter-spacing: 1px;
			}
		}

		.innerBd {

			.innerBdList {
				width: 100%;
				margin: 35px auto 0;
				background: #fff;
				box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.16);
				padding: 12px 8px;
				border-radius: 6px;
				box-sizing: border-box;
			}

			// .innerBdMain {
			// 	width: 100%;
			// 	// margin-left: 30px;
			// 	margin-top: 25px;

			// 	.imgWrap {
			// 		position: relative;
			// 		overflow: hidden;
			// 		text-align: center;

			// 		// .function-pc-img {
			// 		// 	float: left;
			// 		// 	width: 88%;
			// 		// }

			// 		// .function-mobile-img {
			// 		// 	position: absolute;
			// 		// 	right: 70px;
			// 		// 	top: 20px;
			// 		// 	width: 24%;
			// 		// }
			// 		img {
			// 			width: 95%;
			// 			height: auto;
			// 		}
			//    }
			// }
		}
	}

	.innerFooter {
		position: relative;
		width: 100%;
	}

	.innerBdMain {
		width: 100%;
		margin-top: 25px;

		.imgWrap {
			position: relative;
			overflow: hidden;
			text-align: center;

			img {
				width: 95%;
				height: auto;
			}
		}
	}

	.proBg {
		position: absolute;
		bottom: 0;
		width: 100%;
		z-index: 1;
		left: 0;
		background: url(../assets/img/pro-bg.svg) no-repeat;
		// height: 180px;
		height: 140px;
		background-size: cover;
	}

	.listSection:first-child {
		border-bottom: 1px solid rgba(0, 0, 0, .12);
	}

	.listSection {
		width: 100%;
		display: flex;
		flex-direction: row;
	}

	.functionItem {
		// width: 16.67%;
		width: 20%;
		display: inline-block;
		// width: 160px;
		text-align: center;
		padding: 14px 0;
		border-right: 1px solid rgba(0, 0, 0, .12);
	}

	.functionItem:last-child {
		border: none;
	}

	.functionItemIcon {
		display: inline-block;
		width: 32px;
		height: 32px;
		vertical-align: bottom;

		img {
			width: 100%;
			height: 100%;
		}
	}

	.functionItemText {
		font-size: 18px;
		font-weight: bold;
		line-height: 32px;
		vertical-align: middle;
		display: inline-block;
		margin-left: 8px;
	}

	// ***

	// homeMainApp开始
	// .homeMainApp {
	// 	margin-top: 40px;

	// 	.homeMainAppItem {
	// 		display: flex;
	// 		flex-direction: row;
	// 		margin-bottom: 40px;

	// 		.itemDiv {
	// 			width: 50%;
	// 			text-align: center;

	// 			img {
	// 				width: 60%;
	// 				height: auto;
	// 			}

	// 			p {
	// 				text-align: center;
	// 				margin-top: 5px;
	// 			}
	// 		}

	// 	}
	// }

	// .homeMainApp .homeMainAppItem:last-child {
	// 	margin-bottom: 0px;
	// }
	// homeCarouselDiv图片轮播样式开始
	.homeCarouselDiv {
		width: 100%;
		margin-top: 50px;

		.item {
			width: 100%;
			height: 100%;
			position: relative;

			.itemImg {
				height: 62%;
				background: paleturquoise;
				// background: #fff;
				border-radius: 10px;
				// box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.16);
				// box-shadow: 10px 10px 10px -4px rgba(0, 0, 0, .25);
				// background: linear-gradient(-15deg, #0099FF 0%, #0066CC 100%);
				background: #ECECEE;
				position: relative;
				overflow: hidden;

				img {
					width: 100%;
					height: 100%;
				}

				.itemImgDes {
					position: absolute;
					width: 55%;

					h1 {
						font-size: 16px;
						margin-bottom: 8px;
						text-align: center;
					}

					p {
						font-size: 12px;
						text-align: left;
					}
				}
			}

			.itemDes {
				// height: 40%;
				width: 30%;
				left: 35%;
				height: 140px;
				// background: peachpuff;
				position: absolute;
				position: absolute;
				bottom: 30px;
				text-align: center;
				padding-top: 10px;
				background: linear-gradient(-15deg, #0099FF 0%, #0066CC 100%);
				color: #fff;
				border-radius: 6px;

				img {
					width: 42px;
					height: 42px;
				}

				.feature-title {
					font-size: 21px;
					font-weight: normal;
					margin-bottom: 8px;
					color: #fff;
				}

				.feature-intro {
					// color: rgba(21, 31, 42, 0.6);
					font-size: 14px;
					color: #fff;
				}
			}
		}
	}




	// homeCarouselDiv图片轮播样式结束

	// homeMainApp结束

	/*滚动条样式*/
	.popMain::-webkit-scrollbar {
		width: 4.5px; //纵向滚动条的宽度
	}

	.popMain::-webkit-scrollbar-thumb {
		border-radius: 10px;
		-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.15);
		background: rgba(0, 0, 0, 0.08);
	}

	// .popMain::-webkit-scrollbar-track {
	// 	-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.15);
	// 	border-radius: 0;
	// 	background: rgba(0, 0, 0, 0.08);
	// }

	/*滚动条样式*/


	// homeBtn开始**********************
	.popMainItem .homeBtn {
		width: 100%;
		text-align: center;
		// margin-bottom: 35px;
		margin-bottom: 60px;
	}

	.more-btn {
		text-decoration: none;
		position: relative;
		display: inline-block;
		padding: 8px 25px;
		font-size: 14px;
		color: #fff;
		background-color: #409EFF;
		border-radius: 20px;
	}

	.popMainItem .more-btn::before {
		position: absolute;
		content: '';
		width: 100%;
		height: 100%;
		border: 1.5px solid #409EFF;
		top: 50%;
		left: 50%;
		padding: 2px;
		transform: translate(-50%, -50%);
		border-radius: inherit;
		border-radius: 30px;
		-webkit-animation: actif-btn-wave 1s infinite ease-out;
		animation: actif-btn-wave 1s infinite ease-out;
	}

	.popMainItem .more-btn:hover {
		-webkit-animation: anim-moema-1 0.4s forwards;
		animation: anim-moema-1 0.4s forwards;
	}

	@keyframes actif-btn-wave {
		0% {
			-webkit-transform: translate(-50%, -50%) scale(1);
			transform: translate(-50%, -50%) scale(1);
			opacity: 1;
			-webkit-transform-origin: center;
			transform-origin: center;
		}

		100% {
			-webkit-transform: translate(-50%, -50%) scale(1.2);
			transform: translate(-50%, -50%) scale(1.2);
			opacity: 0;
			-webkit-transform-origin: center;
			transform-origin: center;
		}
	}

	@keyframes anim-moema-1 {
		60% {
			-webkit-transform: scale3d(0.8, 0.8, 1);
			transform: scale3d(0.8, 0.8, 1);
		}

		85% {
			-webkit-transform: scale3d(1.1, 1.1, 1);
			transform: scale3d(1.1, 1.1, 1);
		}

		100% {
			-webkit-transform: scale3d(1, 1, 1);
			transform: scale3d(1, 1, 1);
		}
	}

	// homeBtn结束**********************

	// 修改弹窗样式
	.center-dialog .el-dialog__header {
		padding: 0px;
	}

	.center-dialog .el-dialog__headerbtn {
		top: 18px;
		right: 18px;
	}

	.center-dialog .el-dialog__body {
		padding: 30px 10px;
		padding-top: 40px;
	}

	.center-dialog .el-dialog__headerbtn .el-dialog__close {
		font-weight: 600;
	}
</style>
<style>
	/deep/ .el-dialog__wrapper {
		overflow: hidden;
	}

	/deep/ .el-popup-parent--hidden {
		padding-right: 0 !important;
	}

	/* /deep/ .el-dialog {
		background: rgba(238, 241, 249, 0.96);
	} */
</style>
<style>
	body {
		padding-right: 0px !important;
	}

	.viewer-transition {
		z-index: 9999 !important;
	}

	.viewer-canvas {
		/* bottom: 0;
	left: 0;
	overflow: hidden;
	position: absolute;
	right: 0; */
		top: 61px !important;
		padding-top: 20px;
		/* background: pink; */
	}

	.viewer-canvas>img {
		margin-top: 0 !important;
	}

	.viewer-title,
	.viewer-navbar {
		display: none;
	}

	/* 轮播图样式修改 */
	/* .homeCarouselDiv .el-carousel__item--card{
		width: 60%;
	} */

	.homeCarouselDiv .el-carousel__indicators--outside {
		/* display: none; */
	}

	.homeCarouselDiv .el-carousel__button {
		width: 32px;
		height: 3px;
		border-radius: 6px;
	}

	.homeCarouselDiv .el-carousel__arrow {
		display: none !important;
	}

	.el-carousel__arrow:hover {
		background-color: rgba(31, 45, 61, 0);
		display: none !important;
	}
</style>